module.exports = __webpack_public_path__ + "static/media/pre_cast_tag_lin.a5d5f7b4.png";